import { render, staticRenderFns } from "./EmailView.vue?vue&type=template&id=5f407a01"
import script from "./EmailView.vue?vue&type=script&lang=js"
export * from "./EmailView.vue?vue&type=script&lang=js"
import style0 from "./EmailView.vue?vue&type=style&index=0&id=5f407a01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports